import { tenureUpdateApi } from "../../api/tenure/tenureUpdateApi"

type PayloadShape = Parameters<typeof tenureUpdateApi>[0]

export async function tenureUpdateService(payload: PayloadShape, token: string) {
	return await tenureUpdateApi(payload, token)
}
